<template>
    <rkm-modal
        :loading="loading"
        title="Plantonistas"
        large
        ref="Modal"
        hide-footer
    >
        <List />
    </rkm-modal>
</template>

<script>
// Components.
import List from './List'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { List },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    methods: {
        open() {

            this.$refs.Modal.show()
        }
    }
}
</script>